import { ReactNode } from "react";
import styled from "styled-components";

//App
import { formBackGroundStyles } from "./styles";

const StyledBackgroundDiv = styled.div`
  ${formBackGroundStyles}
`;

const FormBackGround = ({ children }: { children: ReactNode }) => {
  return <StyledBackgroundDiv>{children}</StyledBackgroundDiv>;
};

export default FormBackGround;
